import styled from "styled-components";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import { Button } from "@sablier/v2-components/molecules";
import useShortAddress from "@sablier/v2-hooks/useShortAddress";
import { useT } from "@sablier/v2-locales";
import { useAccount } from "~/client/hooks";
import { useFormPrepare, useFormSubmit } from "../logic";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    width: 100%;
  }
`;

const Actions = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: calc(${(props) => props.theme.sizes.edge} * 1);
  width: 100%;
  padding-top: calc(${(props) => props.theme.sizes.edge} * 1);
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxSM} {
    ${Actions} {
      grid-template-columns: 1fr;
    }
  }
`;

function Confirmation() {
  const { t } = useT();
  const { address } = useAccount();
  const { isPrepared } = useFormPrepare();
  const { doSubmit } = useFormSubmit();

  const shortAddress = useShortAddress(address);

  return (
    <Wrapper>
      <Actions>
        {isPrepared ? (
          <Button
            accent={"primary"}
            appearance={"gradient"}
            onClick={doSubmit}
            title={t("structs.transferFromProxyTo", { address: shortAddress })}
            titleShort={t("structs.transferFromProxy")}
          />
        ) : (
          <Button
            accent={"dark200"}
            appearance={"solid"}
            isDisabled
            left={LockClosedIcon}
            title={t("structs.transferFromProxyTo", { address: shortAddress })}
            titleShort={t("structs.transferFromProxy")}
          />
        )}
      </Actions>
    </Wrapper>
  );
}

export default Confirmation;
